module.exports = __webpack_public_path__ + "img/abner.b5842103.png";